export const EMPRESAS = {
  log: "Log Vistoria",
  starcheck: "Star Check Vistoria",
  vlx: "Velox Vistorias",
  tokyo: "Tokyo Vistorias",
} as const;

export type Tenant = keyof typeof EMPRESAS;
